//
// # Mouse Position
//

// Local Imports
import { Point } from "GenAlphaModel";
import { WorldTransforms } from "./transforms";

// # Mouse Position
//
// Including page (app) and lazily-computed schematic coordinates.
//
export class MousePos {
  constructor(
    readonly page: Point, // The page coordinates, as reported by the browser.
    readonly parent: {
      worldTransforms: WorldTransforms;
    } // Reference to the page/sch transforms
  ) {}
  private sch_: Point | null = null; // The schematic coordinates. Null until computed.

  // Get the schematic coordinates, computing them if necessary.
  get sch(): Readonly<Point> {
    if (this.sch_ === null) {
      this.sch_ = this.parent.worldTransforms.toSch(this.page);
    }
    return this.sch_;
  }
}
